/**
 * Pill dividers — thin separators between button groups inside a Pill.
 */

// ---------------------------------------------------------------------------
// Vertical divider between button groups inside a horizontal pill
// ---------------------------------------------------------------------------

export function PillDividerV() {
  return <div className="mx-1 h-[18px] w-px bg-[#e4e4e7]" />;
}

// ---------------------------------------------------------------------------
// Horizontal divider for vertical pills
// ---------------------------------------------------------------------------

export function PillDividerH() {
  return <div className="my-1 h-px w-[18px] bg-[#e4e4e7]" />;
}
